module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jyvMP"))).then(() => module.bundle.root('fijPj'));